import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import UserPreferencesActions from '../UserPreferences/actions';
import * as ACTIONTYPES from './actionTypes';
import { localStorage } from '../../utils/BrowserStorageUtils';

/**
 * Contains the action creator functions that update the 'UAAppconfig'
 * slice of the store.
 * @namespace IntlConfigActions
 */
var actions = /*#__PURE__*/function () {
  function actions() {
    _classCallCheck(this, actions);
  }
  _createClass(actions, null, [{
    key: "isSupportedLanguage",
    value:
    /**
     * Utility function to return true if language is listed in supported languages
     * configuration parameter.
     * @param {*} supportedLanguages a list of supported languages in the
     * format {locale: 'en', displayName:'English'}
     * @param {*} language the language to check
     *
     * @private
     */
    function isSupportedLanguage(supportedLanguages, language) {
      return language && supportedLanguages && _includesInstanceProperty(supportedLanguages).call(supportedLanguages, language);
    }

    /**
     * Pick a language to display by the following rules.
     * 1. If there is a 'selectedLanguage' stored in the browsers local storage use it.
     * 2. Use the browsers default language.
     * 3. Use the default locale as the language.
     *
     * @private
     */
  }, {
    key: "getLanguageToUse",
    value: function getLanguageToUse(supportedLanguages, defaultLocale) {
      // From the browser local storage
      var cachedLanguage = localStorage.getItem('selectedLanguage');
      // From the browser configuration
      var browserLanguage = navigator.language;
      browserLanguage = actions.isSupportedLanguage(supportedLanguages, browserLanguage) ? browserLanguage : undefined;
      cachedLanguage = actions.isSupportedLanguage(supportedLanguages, cachedLanguage) ? cachedLanguage : undefined;
      return cachedLanguage || browserLanguage || defaultLocale;
    }

    /**
     * Load the the Application Configuration into the store.
     *
     * @function
     * @memberof IntlConfigActions
     * @param {IntlShape} intlConfig
     */
  }]);
  return actions;
}();
_defineProperty(actions, "loadIntlConfig", function (dispatch, intlConfig) {
  var _context;
  dispatch({
    type: ACTIONTYPES.LOAD_INTLCONFIG,
    intlConfig: intlConfig
  });

  // Add the users preferred language to the store.
  var userSelectedLanguage = actions.getLanguageToUse(_mapInstanceProperty(_context = intlConfig.locales).call(_context, function (o) {
    return o.locale;
  }), intlConfig.defaultLocale);
  UserPreferencesActions.changeLanguage(dispatch, userSelectedLanguage);
});
export { actions as default };